import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
  } from '@angular/core';

@Component({
    selector: 'app-calendar-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './calendar-header.component.html',
    styleUrls: ['./calendar-header.component.scss'],
    standalone: false
})
export class CalendarHeaderComponent {
  @Input() view: string;

  @Input() viewDate: Date;

  @Input() locale = 'es';

  @Output() viewChange: EventEmitter<string> = new EventEmitter();

  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
}
